<template>
<a href="https://api.whatsapp.com/send?phone=51908825711&text=Hola, tengo una duda!" class="whatsapp" target="_blank">
    <v-icon style="font-size: 40px" class="white--text whatsapp-icon" color="#FFFFFF">
        mdi-whatsapp</v-icon>
</a>
</template>
<script>
export default {

};
</script>